module.exports = __webpack_public_path__ + "static/media/grill.8b01a2a8.svg";